import React from 'react';
import PropTypes from 'prop-types';
import Accordion from 'components/ui/accordion/Accordion';
import Section from 'components/ui/general/Section';
import RuleListItemHeader from './RuleListItemHeader';
import RuleListItemConfiguration from './RuleListItemConfiguration';

function RuleListItem(props) {
    const { onDeleteRule, onUpdate, rule } = props;

    const onUpdateRule = (config) => {
        onUpdate(rule.id, rule.type, config);
    };

    return (
        <Accordion
            accordionContentStyle={ { maxHeight: 'max-content' } }
            label={ <RuleListItemHeader handleOnDelete={ () => {
                return onDeleteRule(rule.id);
            } } title={ rule.type } /> }
            open={ rule.open }
        >
            <Section>
                <RuleListItemConfiguration onUpdate={ onUpdateRule } rule={ rule } />
            </Section>
        </Accordion>
    );
}

RuleListItem.propTypes = {
    onDeleteRule: PropTypes.func.isRequired,
    onUpdate: PropTypes.func,
    rule: PropTypes.shape({
        id: PropTypes.string,
        config: PropTypes.shape({
            attribute: PropTypes.string,
            count: PropTypes.string,
            operator: PropTypes.string,
            value: PropTypes.oneOfType([
                PropTypes.array,
                PropTypes.string,
                PropTypes.number,
                PropTypes.bool,
                PropTypes.object,
            ]),
        }),
        open: PropTypes.bool,
        type: PropTypes.string,
    }),
};

export default RuleListItem;



// WEBPACK FOOTER //
// ./src/pages/discounts/rules/RuleListItem.js